import { marked } from "marked"
import DOMPurify from "dompurify"
import exportColors from "@design/export-colors.json"

marked.setOptions({ gfm: true, breaks: true })

export function convertMarkdownToHtml(markdown: string): string {
  let html = marked.parse(markdown) as string

  html = html.replace(
    /<table>/g,
    `<table border="1" cellpadding="6" cellspacing="0" style="border-collapse: collapse; width: 100%; margin: 16px 0; font-family: Arial, sans-serif; font-size: 12px; background-color: transparent;">`,
  )
  html = html.replace(
    /<th>/g,
    `<th style="border: 1px solid ${exportColors["table-border"]}; padding: 8px 12px; text-align: left; background-color: ${exportColors["table-header-bg"]}; font-weight: 600; color: ${exportColors["table-header-text"]};">`,
  )
  html = html.replace(
    /<td>/g,
    `<td style="border: 1px solid ${exportColors["table-border"]}; padding: 8px 12px; text-align: left; vertical-align: top; background-color: transparent;">`,
  )
  html = html.replace(
    /<tr>/g,
    `<tr style="border: 1px solid ${exportColors["table-border"]}; background-color: transparent;">`,
  )

  return DOMPurify.sanitize(html)
}
